// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import createSvgIcon from '../utils/createSvgIcon';
import React from "react";


export default createSvgIcon(
  <><path d="M9.829 7.991 L 7.679 10.141 8.020 10.480 L 8.361 10.819 10.180 9.000 L 12.000 7.180 13.820 9.000 L 15.639 10.819 15.980 10.480 L 16.321 10.141 14.171 7.991 C 12.988 6.808,12.011 5.840,12.000 5.840 C 11.989 5.840,11.012 6.808,9.829 7.991 M8.000 14.500 L 7.661 14.841 9.830 17.010 L 12.000 19.180 14.170 17.010 L 16.339 14.841 16.000 14.500 L 15.661 14.159 13.831 15.989 L 12.000 17.820 10.169 15.989 L 8.339 14.159 8.000 14.500 " stroke="none" fillRule="evenodd" fill="black"></path></>, 
'SwitchArrowIcon', {
  viewBox: '0 0 24 24',
  height: '24',
  width: '24',
});